import React, { lazy, Suspense } from "react";
import { Route, Routes as RouterRoutes } from "react-router";
import Layout from "../Layout";
import MenuContextWrapper from "../contexts/MenuContext";
import PortalScreen from "./Portal";
import LoginScreen from "./Login";

// The ordering screens are prefetched once the app has loaded, so opening a
// venue doesn't wait on their download after the menu arrives.
const MenuIndex = lazy(() => import("./Menu"));
const MenuScreen = lazy(
  () => import(/* webpackPrefetch: true */ "./Menu/View"),
);
const SendOrderScreen = lazy(
  () => import(/* webpackPrefetch: true */ "./Order/SendOrder"),
);
const OrderStatus = lazy(() => import("./Order/OrderStatus"));
const ControlPanel = lazy(
  () => import(/* webpackPrefetch: true */ "./ControlPanel"),
);
const SignupScreen = lazy(() => import("./Signup"));
const EditProfileScreen = lazy(() => import("./EditProfile"));
const LocationOrdersScreen = lazy(() => import("./LocationOrders"));
const LoyaltyHistoryScreen = lazy(() => import("./LoyaltyHistory"));
const PunchCardsScreen = lazy(() => import("./PunchCards"));
const CheckDetailScreen = lazy(() => import("./CheckDetail"));
const ForgotPasswordScreen = lazy(() => import("./ForgotPassword"));
const ReceiptScreen = lazy(() => import("./Receipt"));

const Routes: React.FC = () => (
  <Suspense fallback={null}>
    <RouterRoutes>
      <Route
        path="/location/:locationId/table?/:tableId?"
        element={
          <MenuContextWrapper>
            <Layout />
          </MenuContextWrapper>
        }
      >
        <Route index element={<ControlPanel />} />
        <Route path="menu" element={<MenuIndex />} />
        <Route path="menu/:section" element={<MenuScreen />} />
        <Route path="order" element={<SendOrderScreen />} />
        <Route path="status/:orderId" element={<OrderStatus />} />
      </Route>

      <Route path="/" element={<PortalScreen />} />
      <Route
        path="/location/:locationId/orders"
        element={<LocationOrdersScreen />}
      />
      <Route
        path="/location/:locationId/orders/:checkId"
        element={<CheckDetailScreen />}
      />
      <Route
        path="/location/:locationId/receipts/:checkId"
        element={<ReceiptScreen />}
      />
      <Route
        path="/location/:locationId/points"
        element={<LoyaltyHistoryScreen />}
      />
      <Route
        path="/location/:locationId/punch-cards"
        element={<PunchCardsScreen />}
      />
      <Route path="/profile/edit" element={<EditProfileScreen />} />
      <Route path="/signup" element={<SignupScreen />} />
      <Route path="/signup/:locationId" element={<SignupScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
    </RouterRoutes>
  </Suspense>
);

export default Routes;
